import { ResolveGuard, AuthGuard } from "@/core/guards";
import { PermissionGuard } from "@/core/guards/permission.guard";

export const lazyLoadRoute = (pageName) => {
  return () =>
    import(/* webpackChunkName: "[request]" */ `@/views/pages/${pageName}`);
};

export default [
  {
    path: "/team",
    beforeEnter: ResolveGuard([AuthGuard]),
    children: [
      {
        path: "",
        name: "TeamList",
        component: lazyLoadRoute("team/TeamIndex.vue"),
        beforeEnter: ResolveGuard([PermissionGuard]),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "create",
        name: "TeamCreate",
        component: lazyLoadRoute("team/TeamCreate.vue"),
        beforeEnter: ResolveGuard([PermissionGuard]),
        meta: {
          permissions: ["ADMIN"],
        },
      },
      {
        path: "edit/:id",
        name: "TeamEdit",
        component: lazyLoadRoute("team/TeamEdit.vue"),
        beforeEnter: ResolveGuard([PermissionGuard]),
        meta: {
          permissions: ["ADMIN"],
        },
      },
    ],
  },
];
